/**
 * @type {Readonly<{SIGINT: string, SIGTERM: string}>}
 */
const SIGNALS = Object.freeze({
  SIGINT: "SIGINT",
  SIGTERM: "SIGTERM",
});

/**
 * @type {Readonly<{LOVING_CAT: string, GRAWLIX_FACE: string, ROCKET: string, OK_HAND: string, WEARY_CAT: string, SPARKLES: string, HANDSHAKE: string, HUGGING_FACE: string, ONCOMING_FIST: string, FLEXED_BICEPS: string, NAUSEATED_FACE: string, BRAIN: string}>}
 */

const EMOJI = Object.freeze({
  ROCKET: "🚀",
  OK_HAND: "👌",
  WEARY_CAT: "🙀",
  LOVING_CAT: "😻",
  HANDSHAKE: "🤝",
  ONCOMING_FIST: "👊",
  HUGGING_FACE: "🤗",
  NAUSEATED_FACE: "🤢",
  GRAWLIX_FACE: "🤬",
  SPARKLES: "✨",
  BRAIN: "🧠",
  FLEXED_BICEPS: "💪",
  RED_HEART: "❤️",
  Heart_Shaped_Eyes: "😍",
});

/**
 * @type {Readonly<{EU: string, SG: string, GB: string, CA: string, US: string}>}
 */

const SUPPORTED_REGIONS = Object.freeze({
  US: "US",
  CA: "CA",
  SG: "SG",
  GB: "GB",
  AU: "AU",
  EU: "EU",
});

/**
 * @type {Readonly<{DE: string, BE: string, PT: string, DK: string, LU: string, IT: string, FR: string, HU: string, ES: string, SE: string, AT: string, CZ: string, IE: string, PL: string, RO: string, NL: string}>}
 */
const SUPPORTED_EU_REGIONS = Object.freeze({
  AT: "AT",
  BE: "BE",
  FR: "FR",
  DE: "DE",
  IE: "IE",
  IT: "IT",
  LU: "LU",
  NL: "NL",
  PT: "PT",
  ES: "ES",
  DK: "DK",
  SE: "SE",
  CZ: "CZ",
  HU: "HU",
  PL: "PL",
  RO: "RO",
});

/**
 * @type {Readonly<{SG: string, AU: string, GB: string, CA: string, US: string}>}
 */
const CURRENCY_MAPPING = Object.freeze({
  US: "USD",
  CA: "CAD",
  SG: "SGD",
  GB: "GBP",
  AU: "AUD",
  EU: "EUR",
});

/**
 * @type {Readonly<{EU: string, AU: string, SG: string, GB: string, US: string, CA: string}>}
 */
const CURRENCY_SIGN = Object.freeze({
  US: "$",
  CA: "$",
  GB: "£",
  AU: "$",
  SG: "$",
  EU: "€",
});

/**
 * @type {Readonly<{EU: number, AU: number, SG: number, GB: number, US: number, CA: number}>}
 */
const DYSON_UNIT_PRICES = Object.freeze({
  US: 599,
  CA: 699,
  GB: 549,
  AU: 800,
  SG: 815,
  EU: 549,
});

/**
 * @type {Readonly<{EU: number, AU: number, SG: number, GB: number, US: number, CA: number}>}
 */
const MOLEKULE_UNIT_PRICES = Object.freeze({
  US: 799,
  CA: 749,
  GB: 610,
  AU: 1067,
  SG: 1087,
  EU: 732,
});

/**
 * @type {number}
 */
const DYSON_FILTER_PRICE_USD = 150;

/**
 * @type {number}
 */
const MOLEKULE_FILTER_PRICE_USD = 140;

/**
 * @type {Readonly<{MILA_UNIT: number, ROOKIE_PARENT: number, BIG_SNEEZE: number, CRITTER_CUDDLER: number, HOME_WRECKER: number, BASIC_BREATHER: number, MAMA_TO_BE: number, OVERREACTOR: number}>}
 */
const PRODUCTS_ID_MAPPING = Object.freeze({
  MILA_UNIT: 1,
  BASIC_BREATHER: 4,
  BIG_SNEEZE: 5,
  ROOKIE_PARENT: 6,
  CRITTER_CUDDLER: 7,
  HOME_WRECKER: 8,
  MAMA_TO_BE: 9,
  OVERREACTOR: 10,
});

/**
 * @type {Readonly<{MILA_UNIT: string, ROOKIE_PARENT: string, BIG_SNEEZE: string, CRITTER_CUDDLER: string, HOME_WRECKER: string, BASIC_BREATHER: string, MAMA_TO_BE: string, OVERREACTOR: string, PEACEKEEPER: string}>}
 */
const PRODUCT_VARIANT_ABBREVIATIONS = Object.freeze({
  MILA_UNIT: "UNIT",
  // ---------- air ----------
  BASIC_BREATHER: "BB",
  BIG_SNEEZE: "BS",
  ROOKIE_PARENT: "RP",
  CRITTER_CUDDLER: "CC",
  HOME_WRECKER: "HW",
  MAMA_TO_BE: "MB",
  OVERREACTOR: "OR",
  PEACEKEEPER: "PC",
  SOCKS: "K5",
  // ---------- air mini ----------
  BASIC_BREATHER_MINI: "BBM",
  BIG_SNEEZE_MINI: "BSM",
  ROOKIE_PARENT_MINI: "RPM",
  CRITTER_CUDDLER_MINI: "CCM",
  HOME_WRECKER_MINI: "HWM",
  MAMA_TO_BE_MINI: "MBM",
  OVERREACTOR_MINI: "ORM",
  PEACEKEEPER_MINI: "PCM",
  SOCKS_MINI: "K3M",
});

/**
 * @type {Readonly<{BB: string, CC: string, BS: string, OR: string, MB: string, RP: string, HW: string}>}
 */
const FILTER_TYPES = Object.freeze({
  BB: "basic-breather",
  BS: "big-sneeze",
  RP: "rookie-parent",
  CC: "critter-cuddler",
  HW: "home-wrecker",
  MB: "mama-to-be",
  OR: "overreactor",
});

/**
 * @type {Readonly<{BB: string, CC: string, BS: string, OR: string, MB: string, RP: string, HW: string}>}
 */
const FILTER_NAMES = Object.freeze({
  BB: "Basic Breather",
  BS: "Big Sneeze",
  RP: "Rookie Parent",
  CC: "Critter Cuddler",
  HW: "Home Wrecker",
  MB: "Mama-to-Be",
  OR: "Overreactor",
});

/**
 * @type {Readonly<{BB: string, CC: string, BS: string, OR: string, PC: string, MB: string, RP: string, HW: string}>}
 */
const FILTER_TYPES_STANDALONE = Object.freeze({
  BB: "basic-breather-filter",
  BS: "big-sneeze-filter",
  RP: "rookie-parent-filter",
  CC: "critter-cuddler-filter",
  HW: "home-wrecker-filter",
  MB: "mama-to-be-filter",
  OR: "overreactor-filter",
  PC: "peacekeeper",
});

/**
 * @type {Readonly<{BB: {title: string, description: string}, CC: {title: string, description: string}, BS: {title: string, description: string}, OR: {title: string, description: string}, PC: {title: string, description: string}, MB: {title: string, description: string}, RP: {title: string, description: string}, HW: {title: string, description: string}}}>
 */
const FILTER_TYPES_METADATA = Object.freeze({
  BB: {
    title:
      "Mila Basic Air Purifier Filter – Clean Your Home’s Air Without Fuss",
    description:
      "The Basic Breather filter handles daily air woes—cooking fumes, dust, and outdoor smog. Big-room clean air without complications.",
  },
  BS: {
    title: "Allergy Air Purifier Filter – The Big Sneeze by Mila",
    description:
      "The Big Sneeze is Mila’s allergy air purifier filter. Stop sneezing, captures pollen, pet dander, dust, and allergens for cleaner, healthier air.",
  },

  RP: {
    title: "Air Purifier Filter for Babies & Parents – The Rookie Parent",
    description:
      "The Rookie Parent is Mila’s air purifier filter for babies—removes VOCs, smoke, and diaper odors so your family breathes cleaner, safer air.",
  },
  CC: {
    title: "Air Purifier Filter for Pets – The Critter Cuddler",
    description:
      "The Critter Cuddler is Mila’s air purifier filter for pets—eliminates pet odors, dander, hair, and allergens so you can breathe fresh, fur-family air.",
  },
  HW: {
    title: "Air Purifier Filter for Home Renovation – Mila Home Wrecker",
    description:
      "The Home Wrecker filter clears paint fumes, new carpet smells, and dust after renovations—fresh, safe air for your family’s new space.",
  },
  MB: {
    title: "Air Purifier Filter for Pregnant Women – The Mama-to-Be",
    description:
      "The Mama-to-Be is Mila’s air purifier filter for pregnant women. Blocks germs, odors, fine particles, and VOCs so you and baby breathe cleaner, safer air.",
  },
  OR: {
    title:
      "Overreactor Air Purifier Filter - Heavy-Duty Protection for Odors & Allergies",
    description:
      "The Overreactor filter wipes out stubborn odors, VOCs, and allergies. Perfect for families wanting cleaner, fresher, safer air at home.",
  },
  PC: {
    title: "",
    description: "",
  },
});

/**
 * @type {Readonly<{BB: {title: string,}, CC: {title: string, }, BS: {title: string, }, OR: {title: string, }, PC: {title: string, }, MB: {title: string, }, RP: {title: string}, HW: {title: string}}}>
 */
const FILTER_TYPES_TITLE = Object.freeze({
  BB: {
    title:
      "The Basic Breather: Simple, Powerful Basic Air Purifier for Everyday",
  },
  BS: {
    title: "The Big Sneeze: Allergy Air Purifier Filter That Works",
  },

  RP: {
    title:
      "The Rookie Parent: Keep Little Lungs Safe with Mila’s Air Purifier Filter for Babies",
  },
  CC: {
    title: "The Critter Cuddler: Air Purifier Filter for Pets",
  },
  HW: {
    title: "The Home Wrecker – Fresh Air After Renovation",
  },
  MB: {
    title: "The Mama-to-Be: Cleaner Air for You and Your Growing Baby",
  },
  OR: {
    title: "The Overreactor – Total Defense for Your Home’s Air",
  },
  PC: {
    title: "",
  },
});
/**
 * @type {Readonly<{BB: string, CC: string, BS: string, OR: string, PC: string, MB: string, RP: string, HW: string}>}
 */
const FILTER_NAMES_STANDALONE = Object.freeze({
  BB: "Basic Breather filter",
  BS: "Big Sneeze filter",
  RP: "Rookie Parent filter",
  CC: "Critter Cuddler filter",
  HW: "Home Wrecker filter",
  MB: "Mama-to-Be filter",
  OR: "Overreactor filter",
  PC: "Peacekeeper",
});

/**
 * @type {Readonly<[string]>}
 */
const PAGES_WITHOUT_ZENDESK = Object.freeze(["/careers"]);

/**
 * @type {string[]}
 */
const PAGES_WITHOUT_NAV = Object.freeze(["/sneakpeek", "/sneakpeek/"]);

/**
 * @type {string[]}
 */
const RELOAD_DOCUMENT_REQUIRED = Object.freeze(["/referral"]);

/**
 * @type {Readonly<{LOADING: string, FAILED: string, IDLE: string, PREFETCHED: string, SUCCEEDED: string}>}
 */

const STATUS = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  PREFETCHED: "prefetched",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
});

/**
 * @type {Readonly<{UK: string, US: string, CA: string, EU: string}>}
 */
const REGION_FLAGS = Object.freeze({
  GB: "🇬🇧",
  US: "🇺🇸",
  CA: "🇨🇦",
  EU: "🇪🇺",
});

export {
  SIGNALS,
  EMOJI,
  SUPPORTED_REGIONS,
  SUPPORTED_EU_REGIONS,
  CURRENCY_MAPPING,
  CURRENCY_SIGN,
  DYSON_UNIT_PRICES,
  MOLEKULE_UNIT_PRICES,
  DYSON_FILTER_PRICE_USD,
  MOLEKULE_FILTER_PRICE_USD,
  PRODUCTS_ID_MAPPING,
  PRODUCT_VARIANT_ABBREVIATIONS,
  FILTER_TYPES,
  FILTER_TYPES_STANDALONE,
  FILTER_NAMES,
  FILTER_NAMES_STANDALONE,
  PAGES_WITHOUT_ZENDESK,
  PAGES_WITHOUT_NAV,
  RELOAD_DOCUMENT_REQUIRED,
  STATUS,
  REGION_FLAGS,
  FILTER_TYPES_METADATA,
  FILTER_TYPES_TITLE,
};
